import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'ventilation',

  type : 'Scénario personnalisé',
  
  label: 'Scénario',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-leaf-circle',
  }
}